module.exports = __webpack_public_path__ + "static/media/report-sleep-icon.6479c756.svg";